import JSZip from "jszip";
import { useSelector, useDispatch } from "react-redux";
import commonActions from "../redux/common/actions";
import generateAdmitcardActions from "../redux/admitcardgeneration/action";
import axios from "axios";
import Cookies from "js-cookie";
import { API_URL } from "../utils/constants";
import Barcode from 'react-barcode';
import ReactDOMServer from 'react-dom/server';
const modifyWordFileCard = async (props) => {
  const {
    uploadfile,
    dispatch,
    filteredResults,
    setModifiedFileUrl,
    setPreview,
    placeholders,
    setMessage,
    setIsDialogOpen,
    setMetaData,
    setShowIframe,
    barcodeDataUrl,
    candidateName
  } = props;
  const now = new Date();

  dispatch({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    let fileBlob;

    // Check if uploadfile is a URL (string)
    if (typeof uploadfile === "string") {
      const response = await fetch(uploadfile);
      if (!response.ok) {
        throw new Error("Failed to fetch the file from the URL.");
      }
      fileBlob = await response.blob(); // Convert the response to a Blob
    } else if (uploadfile instanceof Blob || uploadfile instanceof File) {
      // If uploadfile is already a Blob or File, use it directly
      fileBlob = uploadfile;
    } else {
      throw new Error(
        "Invalid uploadfile type. Expected a URL, Blob, or File."
      );
    }
    const arrayBuffer = await fileBlob.arrayBuffer();
    const zip = await JSZip.loadAsync(arrayBuffer);
    const documentXml = await zip.file("word/document.xml").async("string");
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(documentXml, "application/xml");
    let hasImagePlaceholder = false;
    let hasSignImagePlaceholder = false;
    let hasBarcodePlaceholder = false;
    const textNodes = Array.from(xmlDoc.getElementsByTagName("w:t"));
    let replacedWords = [];
    textNodes.forEach((node) => {
      let originalText = node.textContent;

      placeholders.forEach(({ replaceText, value }) => {
        if (originalText?.includes(replaceText?.source)) {
          replacedWords.push(originalText);
          originalText = originalText.replace(replaceText, value);
        }
      });

      if (originalText.includes("<image>")) {
        originalText = "{%image}";
        // hasImagePlaceholder = true;
      }

      if (originalText.includes("<signature>")) {
        originalText = originalText.replace(/<signature>/g, "{%signature}");
        // hasSignImagePlaceholder = true;
      }
      if (originalText.includes("<barcode>")) {
        originalText = originalText.replace(/<barcode>/g, "{%barcode}");
        // hasBarcodePlaceholder = true;
      }

      node.textContent = originalText;
    });

    if (hasImagePlaceholder) {
      const imageUrl = filteredResults?.fileurl_1;
      const imageResponse = await fetch(imageUrl);

      if (!imageResponse.ok) {
        throw new Error("Failed to fetch the image.");
      }
      const imageBlob = await imageResponse.blob();

      zip.file("word/media/image1.png", imageBlob);

      const relsXml = await zip
        .file("word/_rels/document.xml.rels")
        .async("string");
      const relsDoc = parser.parseFromString(relsXml, "application/xml");
      const relationships = relsDoc.getElementsByTagName("Relationships")[0];

      const newRel = relsDoc.createElement("Relationship");
      newRel.setAttribute("Id", "rId100");
      newRel.setAttribute(
        "Type",
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image"
      );
      newRel.setAttribute("Target", "media/image1.png");
      relationships.appendChild(newRel);

      const serializer = new XMLSerializer();
      const updatedRelsXml = serializer.serializeToString(relsDoc);
      zip.file("word/_rels/document.xml.rels", updatedRelsXml);

      const drawingXml = `
        <w:r>
          <w:drawing>
            <wp:inline>
              <wp:extent cx="1905000" cy="1905000"/>
              <wp:docPr id="1" name="Picture 1"/>
              <a:graphic xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main">
                <a:graphicData uri="http://schemas.openxmlformats.org/drawingml/2006/picture">
                  <pic:pic xmlns:pic="http://schemas.openxmlformats.org/drawingml/2006/picture">
                    <pic:nvPicPr>
                      <pic:cNvPr id="0" name="Picture 1"/>
                      <pic:cNvPicPr/>
                    </pic:nvPicPr>
                    <pic:blipFill>
                      <a:blip r:embed="rId100"/>
                      <a:stretch>
                        <a:fillRect/>
                      </a:stretch>
                    </pic:blipFill>
                    <pic:spPr>
                      <a:xfrm>
                        <a:off x="0" y="0"/>
                        <a:ext cx="1905000" cy="1905000"/>
                      </a:xfrm>
                      <a:prstGeom prst="rect">
                        <a:avLst/>
                      </a:prstGeom>
                    </pic:spPr>
                  </pic:pic>
                </a:graphicData>
              </a:graphic>
            </wp:inline>
          </w:drawing>
        </w:r>
      `;
      const parent = textNodes.find(
        (node) => node.textContent === ""
      ).parentNode;
      parent.innerHTML = drawingXml;
    }

    if (hasSignImagePlaceholder) {
      const signImageUrl = filteredResults?.fileurl_2;
      const signImageResponse = await fetch(signImageUrl);
      if (!signImageResponse.ok) {
        throw new Error("Failed to fetch the signature image.");
      }
      const signImageBlob = await signImageResponse.blob();

      zip.file("word/media/signature.png", signImageBlob);

      const relsXml = await zip
        .file("word/_rels/document.xml.rels")
        .async("string");
      const relsDoc = parser.parseFromString(relsXml, "application/xml");
      const relationships = relsDoc.getElementsByTagName("Relationships")[0];

      const newRel = relsDoc.createElement("Relationship");
      newRel.setAttribute("Id", "rId101");
      newRel.setAttribute(
        "Type",
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image"
      );
      newRel.setAttribute("Target", "media/signature.png");
      relationships.appendChild(newRel);

      const serializer = new XMLSerializer();
      const updatedRelsXml = serializer.serializeToString(relsDoc);
      zip.file("word/_rels/document.xml.rels", updatedRelsXml);

      const signatureDrawingXml = `
        <w:r>
          <w:drawing>
            <wp:inline>
              <wp:extent cx="1905000" cy="1905000"/>
              <wp:docPr id="2" name="Signature"/>
              <a:graphic xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main">
                <a:graphicData uri="http://schemas.openxmlformats.org/drawingml/2006/picture">
                  <pic:pic xmlns:pic="http://schemas.openxmlformats.org/drawingml/2006/picture">
                    <pic:nvPicPr>
                      <pic:cNvPr id="0" name="Signature"/>
                      <pic:cNvPicPr/>
                    </pic:nvPicPr>
                    <pic:blipFill>
                      <a:blip r:embed="rId101"/>
                      <a:stretch>
                        <a:fillRect/>
                      </a:stretch>
                    </pic:blipFill>
                    <pic:spPr>
                      <a:xfrm>
                        <a:off x="0" y="0"/>
                        <a:ext cx="1905000" cy="1905000"/>
                      </a:xfrm>
                      <a:prstGeom prst="rect">
                        <a:avLst/>
                      </a:prstGeom>
                    </pic:spPr>
                  </pic:pic>
                </a:graphicData>
              </a:graphic>
            </wp:inline>
          </w:drawing>
        </w:r>
      `;
      const parent = textNodes.find(
        (node) => node.textContent === "signature"
      ).parentNode;
      parent.innerHTML = signatureDrawingXml;
    }
    if (hasBarcodePlaceholder) {
      const barcodeImageUrl = barcodeDataUrl;
      const barcodeImageResponse = await fetch(barcodeImageUrl);
      if (!barcodeImageResponse.ok) {
        throw new Error("Failed to fetch the barcode image.");
      }
      const barcodeImageBlob = await barcodeImageResponse.blob();

      zip.file("word/media/barcode.png", barcodeImageBlob);

      const relsXml = await zip
        .file("word/_rels/document.xml.rels")
        .async("string");
      const relsDoc = parser.parseFromString(relsXml, "application/xml");
      const relationships = relsDoc.getElementsByTagName("Relationships")[0];

      const newRel = relsDoc.createElement("Relationship");
      newRel.setAttribute("Id", "rId102");
      newRel.setAttribute(
        "Type",
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image"
      );
      newRel.setAttribute("Target", "media/barcode.png");
      relationships.appendChild(newRel);

      const serializer = new XMLSerializer();
      const updatedRelsXml = serializer.serializeToString(relsDoc);
      zip.file("word/_rels/document.xml.rels", updatedRelsXml);

      const barcodeDrawingXml = `
        <w:r>
          <w:drawing>
            <wp:inline>
              <wp:extent cx="4005000" cy="2505000"/>
              <wp:docPr id="3" name="Barcode"/>
              <a:graphic xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main">
                <a:graphicData uri="http://schemas.openxmlformats.org/drawingml/2006/picture">
                  <pic:pic xmlns:pic="http://schemas.openxmlformats.org/drawingml/2006/picture">
                    <pic:nvPicPr>
                      <pic:cNvPr id="0" name="Barcode"/>
                      <pic:cNvPicPr/>
                    </pic:nvPicPr>
                    <pic:blipFill>
                      <a:blip r:embed="rId102"/>
                      <a:stretch>
                        <a:fillRect/>
                      </a:stretch>
                    </pic:blipFill>
                    <pic:spPr>
                      <a:xfrm>
                        <a:off x="0" y="0"/>
                        <a:ext cx="4005000" cy="2505000"/>
                      </a:xfrm>
                      <a:prstGeom prst="rect">
                        <a:avLst/>
                      </a:prstGeom>
                    </pic:spPr>
                  </pic:pic>
                </a:graphicData>
              </a:graphic>
            </wp:inline>
          </w:drawing>
        </w:r>
      `;
      const parent = textNodes.find(
        (node) => node.textContent === "barcode"
      ).parentNode;
      parent.innerHTML = barcodeDrawingXml;
    }
    //     if (hasBarcodePlaceholder) {
    //   const barcodeValue = "barcode-example";
    //   const barcodeSvgString = ReactDOMServer.renderToStaticMarkup(
    //     <Barcode value={barcodeValue} />
    //   );

    //   // Convert SVG string to Blob
    //   const svgBlob = new Blob([barcodeSvgString], { type: 'image/svg+xml' });

    //   // Convert SVG to PNG using Canvas
    //   const svgUrl = URL.createObjectURL(svgBlob);
    //   const img = new Image();
    //   img.src = svgUrl;

    //   await new Promise((resolve) => {
    //     img.onload = () => {
    //       const canvas = document.createElement('canvas');
    //       canvas.width = img.width;
    //       canvas.height = img.height;
    //       const ctx = canvas.getContext('2d');
    //       ctx.drawImage(img, 0, 0);

    //       canvas.toBlob(async (pngBlob) => {
    //         zip.file("word/media/barcode.png", pngBlob);

    //         // Add Relationship for Barcode PNG
    //         const relsXml = await zip.file("word/_rels/document.xml.rels").async("string");
    //         const relsDoc = parser.parseFromString(relsXml, "application/xml");
    //         const relationships = relsDoc.getElementsByTagName("Relationships")[0];

    //         const newRel = relsDoc.createElement("Relationship");
    //         newRel.setAttribute("Id", "rId102");
    //         newRel.setAttribute("Type", "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image");
    //         newRel.setAttribute("Target", "media/barcode.png");
    //         relationships.appendChild(newRel);

    //         const serializer = new XMLSerializer();
    //         const updatedRelsXml = serializer.serializeToString(relsDoc);
    //         zip.file("word/_rels/document.xml.rels", updatedRelsXml);

    //         // Insert Barcode into document.xml
    //         const barcodeDrawingXml = `
    //           <w:r>
    //             <w:drawing>
    //               <wp:inline>
    //                 <wp:extent cx="1905000" cy="1905000"/>
    //                 <wp:docPr id="2" name="Barcode"/>
    //                 <a:graphic xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main">
    //                   <a:graphicData uri="http://schemas.openxmlformats.org/drawingml/2006/picture">
    //                     <pic:pic xmlns:pic="http://schemas.openxmlformats.org/drawingml/2006/picture">
    //                       <pic:nvPicPr>
    //                         <pic:cNvPr id="0" name="Barcode"/>
    //                         <pic:cNvPicPr/>
    //                       </pic:nvPicPr>
    //                       <pic:blipFill>
    //                         <a:blip r:embed="rId102"/>
    //                         <a:stretch>
    //                           <a:fillRect/>
    //                         </a:stretch>
    //                       </pic:blipFill>
    //                       <pic:spPr>
    //                         <a:xfrm>
    //                           <a:off x="0" y="0"/>
    //                           <a:ext cx="1905000" cy="1905000"/>
    //                         </a:xfrm>
    //                         <a:prstGeom prst="rect">
    //                           <a:avLst/>
    //                         </a:prstGeom>
    //                       </pic:spPr>
    //                     </pic:pic>
    //                   </a:graphicData>
    //                 </a:graphic>
    //               </wp:inline>
    //             </w:drawing>
    //           </w:r>
    //         `;

    //         const parent = textNodes.find(node => node.textContent === "barcode").parentNode;
    //         parent.innerHTML = barcodeDrawingXml;

    //         resolve();
    //       }, "image/png");
    //     };
    //   });
    // }



    if (replacedWords.length === 0) {
      setMessage("No Metadata matches.");
      dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
      return;
    }

    const serializer = new XMLSerializer();
    const modifiedXml = serializer.serializeToString(xmlDoc);
    zip.file("word/document.xml", modifiedXml);

    const modifiedFileBlob = await zip.generateAsync({ type: "blob" });
    const modifiedFile = new File([modifiedFileBlob], "Modified.docx", {
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });
    // const link = document.createElement("a");
    // link.href = URL.createObjectURL(modifiedFile);
    // link.download = "Modified.docx";
    // link.click();
    const formData = new FormData();
    formData.append("docs", modifiedFile);
    dispatch({ type: commonActions.SET_PAGE_LOADER, payload: true });

    await dispatch({
      type: generateAdmitcardActions.GET_ADMITCARD_URL,
      payload: {
        modifiedFile,
        candidateName,
        setPreview,
        setIsDialogOpen,
        setMetaData,
        setShowIframe,
        setPreview,
        image: filteredResults?.fileurl_1,
        signature: filteredResults?.fileurl_2,
        barcode: barcodeDataUrl,
      }
    });

    setModifiedFileUrl(URL.createObjectURL(modifiedFileBlob));

  } catch (error) {
    dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
  }
};

export default modifyWordFileCard;
